module.exports = __webpack_public_path__ + "img/ring_r_skip_1_0@3x.e345d08e.png";